import { Injectable, Inject} from '@angular/core';


export  class ClientContactDO{
  
    public  id :Number;
	
	public  typeCd:String;
	
	public  subTypeCd:String;
	
	public  ISD:String;
	
	public  STD:String;

	public contactNum:String;
	
	public extensionNum:String;
	
	public  prefferedFl:Boolean;
	
	public  getTypeCd():String {
		return this.typeCd;
	}
	public setTypeCd( typeCd:String) {
		this.typeCd = typeCd;
	}
	public  getSubTypeCd():String {
		return this.subTypeCd;
	}
	public setSubTypeCd( subTypeCd:String) {
		this.subTypeCd = subTypeCd;
	}
	public  getISD():String {
		return this.ISD;
	}
	public setISD( iSD:String) {
		this.ISD = iSD;
	}
	public getSTD():String {
		return this.STD;
	}
	public setSTD( sTD:String) {
		this.STD = sTD;
	}
	public  getContactNum():String {
		return this.contactNum;
	}
	public setContactNum( contactNum:String) {
		this.contactNum = contactNum;
	}
	public getExtensionNum():String {
		return this.extensionNum;
	}
	public setExtensionNum(extensionNum:String) {
		this.extensionNum = extensionNum;
	}
	
	public  getId():Number {
	
		return this.id;
	}
	
	public  getPrefferedFl():Boolean {
		return this.prefferedFl;
	}
	public setPrefferedFl( prefferedFl:Boolean) {
		this.prefferedFl = prefferedFl;
	}
	public  setId( id:Number) {
		this.id = id;
	}

	

	

}